import React from 'react';
import { Plus, Edit2 } from 'lucide-react';
import { MobileSelect } from '../ui/MobileSelect';

interface FormationSelectorProps {
  selectedFormation: string;
  availableFormations: {value: string, label: string}[];
  onFormationChange: (formationName: string) => void;
  onCreateFormation: () => void;
  onManageFormations: () => void;
  showFormationManager: boolean;
  hasCustomFormations: boolean;
  isDefaultFormation?: boolean;
  onSetAsDefault?: (formationName: string, isDefault: boolean) => void;
}

export const FormationSelector: React.FC<FormationSelectorProps> = ({
  selectedFormation,
  availableFormations,
  onFormationChange,
  onCreateFormation,
  onManageFormations,
  showFormationManager,
  hasCustomFormations,
  isDefaultFormation = false,
  onSetAsDefault
}) => {
  return (
    <div className="flex items-center gap-1 sm:gap-2 mr-1 sm:mr-2">
      <MobileSelect
        value={selectedFormation}
        onChange={onFormationChange}
        options={[
          { value: '', label: 'Select Formation' },
          ...availableFormations,
        ]}
        className="bg-white border border-gray-300 text-gray-900 text-xs sm:text-sm rounded-lg p-1 sm:p-1.5 max-w-[160px] sm:max-w-[200px]"
        aria-label="Select Formation"
        sheetTitle="Select Formation"
      />
      
      {/* Make Default checkbox */}
      {selectedFormation && onSetAsDefault && (
        <label className="flex items-center gap-1 text-xs">
          <input
            type="checkbox"
            checked={isDefaultFormation}
            onChange={(e) => onSetAsDefault(selectedFormation, e.target.checked)}
            className="w-3 h-3"
          />
          <span className="text-gray-600">Default</span>
        </label>
      )}
      
      {/* Formation management buttons */}
      {showFormationManager && (
        <div className="flex gap-1">
          <button
            onClick={onCreateFormation}
            className="btn-secondary flex items-center justify-center gap-1 px-1.5 sm:px-2 py-1 text-xs"
            title="Add New Formation"
          >
            <Plus className="w-4 h-4" />
            <span className="hidden sm:inline">Add</span>
          </button>
          {(selectedFormation || hasCustomFormations) && (
            <button
              onClick={onManageFormations}
              className="btn-secondary flex items-center justify-center gap-1 px-1.5 sm:px-2 py-1 text-xs"
              title={selectedFormation ? `Edit ${selectedFormation}` : "Edit Formation"}
              disabled={!selectedFormation}
            >
              <Edit2 className="w-4 h-4" />
              <span className="hidden sm:inline">Edit</span>
            </button>
          )}
        </div>
      )}
    </div>
  );
}; 